import React, { useCallback, useContext } from 'react';
import type { IHeaderParams } from 'ag-grid-community';
import styled from 'styled-components';

import Cell from '../Cell';
import EntityButtons from 'components/EntityButtons';
import MetricMatrixContext from 'contexts/MetricMatrixContext';
import formatDateLabel from 'components/V5Gadget/formatDateLabel';

interface DimensionAHeaderParams extends IHeaderParams {
  dimensionValue: string;
  isDateDimension: boolean;
  interval?: FleetOps.Interval | 'fixed' | 'fiscalPeriod';
  displayValue?: string;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  padding: 8px 0;
`;

const DimensionAHeaderCell = (props: DimensionAHeaderParams) => {
  const { dimensionValue, isDateDimension, interval, displayValue } = props;
  const { onDrillDown } = useContext(MetricMatrixContext);

  const headerText = (() => {
    if (displayValue) return displayValue;
    if (isDateDimension && interval) {
      return formatDateLabel(
        dimensionValue,
        interval,
        true,
        undefined,
        true,
        false,
        true,
      );
    }
    return dimensionValue;
  })();

  const tooltipText = (() => {
    if (displayValue) return displayValue;
    if (isDateDimension && interval) {
      return formatDateLabel(dimensionValue, interval, true, undefined, true);
    }
    return dimensionValue;
  })();

  const onClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      onDrillDown(dimensionValue, event.metaKey || event.ctrlKey);
    },
    [dimensionValue, onDrillDown],
  );

  return (
    <Cell disableLink>
      <Wrapper>
        <EntityButtons.Interaction
          text={headerText}
          onClick={onClick}
          tooltip={`Click to drill into ${tooltipText}`}
        />
      </Wrapper>
    </Cell>
  );
};

export default DimensionAHeaderCell;
